'use client';

import { createContext, useContext } from 'react';
import type { Tournament } from '@/lib/types/auction';

export const TournamentContext = createContext<Tournament | null>(null);

export function useTournament() {
  const tournament = useContext(TournamentContext);
  if (!tournament) {
    throw new Error('useTournament must be used within TournamentContext');
  }
  return tournament;
}
